import React from 'react';
import { RadioGroup } from 'components/shared/RadioGroup';
import { InfoCircle } from './InfoCircle';

export const SolePractitionerToggle = ({
  disabled,
  value,
  onChange,
  formLabel,
}) => (
  <RadioGroup
    sectionComponentSize="large"
    disabled={disabled}
    disabledMessage="Practices with more than one vet cannot be Sole Practitioners"
    name="isSolePractitioner"
    value={value}
    formLabel={
      disabled ? (
        formLabel || 'Sole Practitioner?'
      ) : (
        <>
          {formLabel || 'Sole Practitioner?'}
          <InfoCircle
            text={
              <div className="text-center">
                A sole practitioner is a licensed professional who
                <br />
                operates a veterinary practice without any other partners.
              </div>
            }
            clickable={true}
          />
        </>
      )
    }
    onChange={onChange}
    radioList={[
      {
        value: true,
        label: 'Yes',
      },
      {
        value: false,
        label: 'No',
      },
    ]}
  />
);
